import { useState } from "react";
import { Select, CourseSet } from "../../types/requirement.response";
import { DEFAULT_SEMESTER } from "../../constants";
import FilterToggle from "./FilterToggle";
import CourseSetRows from "./CourseSetRows";
import RequirementTabBar from "../shared/RequirementTabBar";
import { ReqDetailBaseProps } from "./types";

interface OptionGroupReqDetailProps extends ReqDetailBaseProps {
    onToggleFilter: () => void;
}

export default function OptionGroupReqDetail({
    programInfo,
    requirement,
    coursesMap,
    isSliceLoaded,
    handleAddCourse,
    handleDeleteCourse,
    handleFavoriteCourse,
    optimisticFavorites,
    userCourses,
    hideUnavailable,
    onToggleFilter,
}: OptionGroupReqDetailProps) {
    const rootNode = requirement.rootNode as Select;
    const groups = rootNode.children.filter(
        (child): child is Select => child.type === "SELECT"
    );

    const [activeTab, setActiveTab] = useState(0);
    const activeGroup = groups[activeTab];
    const courseSets = activeGroup
        ? activeGroup.children.filter((child): child is CourseSet => child.type === "COURSE_SET")
        : [];

    if (groups.length === 0) {
        return (
            <p className="px-4 py-6 text-sm text-gray-400 italic">
                No options found for this requirement.
            </p>
        );
    }

    return (
        <>
            <div className="mt-4">
                <RequirementTabBar
                    items={groups}
                    fulfilledIds={rootNode.fulfilledChildIds}
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                />
                <div className="flex justify-end mt-4">
                    <FilterToggle active={hideUnavailable} onToggle={onToggleFilter} semester={DEFAULT_SEMESTER} />
                </div>
            </div>
            <table className="w-full border-collapse mt-4">
                <tbody>
                    {courseSets.length === 0 ? (
                        <tr>
                            <td colSpan={4} className="px-4 py-6 text-sm text-gray-400 italic">
                                No course groups found in this option.
                            </td>
                        </tr>
                    ) : (
                        courseSets.map(courseSet => (
                            <CourseSetRows
                                key={courseSet.id}
                                courseSet={courseSet}
                                programInfo={programInfo}
                                coursesMap={coursesMap}
                                isSliceLoaded={isSliceLoaded}
                                requirementId={requirement.info.id}
                                handleAddCourse={handleAddCourse}
                                handleDeleteCourse={handleDeleteCourse}
                                handleFavoriteCourse={handleFavoriteCourse}
                                optimisticFavorites={optimisticFavorites}
                                userCourses={userCourses}
                                hideUnavailable={hideUnavailable}
                                showHeader
                                emptyMessage="No courses found in this group."
                            />
                        ))
                    )}
                </tbody>
            </table>
        </>
    );
}
